module.exports = __webpack_public_path__ + "static/media/29EUNOG18.df3c09f6.jpg";